const initialState = {
  bookingPageList: [],
  bookingPageDrawer: {},
};

export default {
  namespace: 'bookingPages',

  state: initialState,

  effects: {

  },

  reducers: {

    toggleDrawer(state, action) {
      return {
        ...state,
        bookingPageDrawer: action.payload || {},
      };
    },

    openCreateDrawer(state) {
      return {
        ...state,
        bookingPageDrawer: { mode: 'create' },
      };
    },

    closeDrawer(state) {
      return {
        ...state,
        bookingPageDrawer: {},
      };
    },

    reset() {
      return initialState;
    },
  },
};
